/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Screenshotfailed_Title1Inputs */

const en_analytics_screenshotfailed_title1 = /** @type {(inputs: Analytics_Screenshotfailed_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to capture screenshot`)
};

/**
* | output |
* | --- |
* | "Failed to capture screenshot" |
*
* @param {Analytics_Screenshotfailed_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_screenshotfailed_title1 = /** @type {((inputs?: Analytics_Screenshotfailed_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Screenshotfailed_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_screenshotfailed_title1(inputs)
});
export { analytics_screenshotfailed_title1 as "analytics_screenshotFailed_title" }